import styled, { css } from 'styled-components'
import Link from 'components/elements/link'
import { calculateResponsiveSize, mediaMax } from 'styles/media-queries'
import { colors } from 'styles/global-styles'

// Both rows share one track set so the link columns line up down the footer:
// 763 and 970 of the 1280 design, measured off the 40 of left padding.
const rowGrid = css`
  display: grid;
  grid-template-columns: ${calculateResponsiveSize(722)} 1fr;

  ${mediaMax('mobile')} {
    display: flex;
    flex-direction: column;
  }
`

const linkColumns = css`
  display: grid;
  grid-template-columns: ${calculateResponsiveSize(207)} 1fr;
`

export const FooterTop = styled.div`
  ${rowGrid}
`

export const FooterTopLeft = styled.div`
  img {
    width: ${calculateResponsiveSize(269)};
  }

  ${mediaMax('mobile')} {
    img {
      width: ${calculateResponsiveSize(181)};
    }
  }
`

export const FooterTopRight = styled.div`
  ${linkColumns}

  font-style: normal;

  ${mediaMax('mobile')} {
    /* One column, 27 down from the logo box to the first link's line box. */
    display: flex;
    flex-direction: column;
    gap: ${calculateResponsiveSize(8)};
    margin-top: ${calculateResponsiveSize(27)};
    opacity: 0.7;
  }
`

export const TopList = styled.ul`
  display: flex;
  flex-direction: column;
  /* 20 in the design is between cap boxes; the 14 line box eats the rest. */
  gap: ${calculateResponsiveSize(13)};
  margin: 0;
  padding: 0;
  list-style: none;

  ${mediaMax('mobile')} {
    /* Same trim, off the 14 cap gap and the 9/1.4 line box. */
    gap: ${calculateResponsiveSize(8)};
  }
`

export const TopListItem = styled.li`
  a {
    color: ${colors.sand};

    /* Small Body - Sans */
    font-family: 'Gotham';
    font-size: ${calculateResponsiveSize(10)};
    font-weight: 500;
    line-height: 1.4;
    text-transform: uppercase;
  }

  ${mediaMax('mobile')} {
    /* Size the item itself so the row is the link's line box, not the
       inherited 14/1.25 strut. */
    font-size: ${calculateResponsiveSize(9)};
    line-height: 1.4;
    a {
      font-size: inherit;
    }
  }
`

export const Title = styled.div`
  margin: 0 0 ${calculateResponsiveSize(10)} 0;
  font-family: 'Gotham';
  font-size: ${calculateResponsiveSize(20)};
  line-height: 1.2;
`

export const FooterBottom = styled.div`
  ${rowGrid}

  ${mediaMax('mobile')} {
    margin-top: ${calculateResponsiveSize(23)};
  }
`

export const FooterBottomLeft = styled.div``

export const Copy = styled.div`
  font-family: 'Gotham';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 500;
  line-height: 1.4;

  ${mediaMax('mobile')} {
    font-weight: 400;
    text-transform: uppercase;
  }
`

export const FooterBottomRight = styled.div``

export const List = styled.ul`
  ${linkColumns}

  margin: 0;
  padding: 0;
  list-style: none;

  ${mediaMax('mobile')} {
    display: flex;
    gap: ${calculateResponsiveSize(21)};
    margin-top: ${calculateResponsiveSize(23)};
  }
`

export const ListItem = styled.li`
  a {
    color: ${colors.sand};
    font-family: 'Gotham';
    font-size: ${calculateResponsiveSize(10)};
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
  }

  ${mediaMax('mobile')} {
    font-size: ${calculateResponsiveSize(10)};
    line-height: 1.4;
  }
`

export const ListItemLink = styled(Link)``
